module.exports = __webpack_public_path__ + "img/resized-APP-0003-2.f2594f57.png";